import { useEffect } from 'react';

/**
 * 🔴 EVERY PAGE NAMES ITSELF IN THE TAB — design-system DS-11b1 (§1.7; F261, F262, F265, WCAG 2.4.2).
 *
 * The three apps' tabs said "Workbook", "Workbook Portal" or "Workbook System" on every page, so a person with ten
 * tabs open, or a screen reader announcing the window, could not tell an invoice from the ledger. `PageHeader` and
 * `DocHead` call this with their heading, so every screen with a head is named; each app's signed-out card (`Centred`)
 * names itself, and the pages with their own h1 call it.
 *
 * The app's own name is read ONCE, from the title its `index.html` writes, when this module loads (plan C6): the kit
 * cannot know which app it is in, and this keeps the hook to one argument. `null` (a head whose title is not text and
 * gives no `titleText`) leaves the tab as it is. On unmount the app's name comes back, so a page left for one without
 * a head does not keep the last page's name.
 */
const APP = document.title || 'Workbook';

export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} · ${APP}`;
    return () => {
      document.title = APP;
    };
  }, [title]);
}

/** The hook for a class component (the crash screen): draws nothing, names the tab while it is mounted. */
export function DocumentTitle({ title }: { title: string }): null {
  useDocumentTitle(title);
  return null;
}
